import { useState } from "react";
import ApiService from "../api/app.api";
import DropdownSelect from "./dropdown_select";
import { useSelector } from "react-redux";

const api = new ApiService();
const AddCategory = ({ refetch }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedOption, setSelectedOption] = useState("");
	const [title, setTitle] = useState("");
	const user = useSelector((st) => st.user).user;
	const handleCreate = async () => {
		const body = JSON.stringify({
			title,
			isParent: true,
		});
		const data = await api.postRequestwithBearer(
			`api/v1/duas/categories`,
			body,
			user.token
		);
		console.log("DATA", data);

		closeModal();
		refetch();
	};
	const openModal = () => {
		setIsModalOpen(true);
	};

	const closeModal = () => {
		setIsModalOpen(false);
	};
	const handleOptionChange = (event) => {
		setSelectedOption(event.target.value);
	};
	return (
		<div>
			<button
				className="bg-emerald-500 p-2 text-white font-medium rounded-md uppercase mx-4"
				onClick={openModal}>
				+ add
			</button>
			{isModalOpen && (
				<div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-black bg-opacity-50 ">
					<div className="bg-white rounded shadow-lg p-8 w-[48%] h-auto">
						<h2 className="text-2xl font-bold mb-4">Create Dua or Tawassol</h2>
						<hr />
						<div className="py-2 px-2">
							<DropdownSelect
								selectedOption={selectedOption}
								handleOptionChange={handleOptionChange}
							/>
							<div className="flex items-center space-x-2 py-2">
								<label
									htmlFor="dropdown"
									className="text-sm font-medium text-gray-700">
									Title:
								</label>
								<div className="mt-1">
									<input
										id="name"
										name="name"
										type="text"
										required
										value={title}
										onChange={(event) => setTitle(event.target.value)}
										className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
									/>
								</div>
							</div>
						</div>
						<div className="mt-auto flex justify-end">
							<button
								className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-8 rounded mr-2 uppercase"
								onClick={closeModal}>
								Close
							</button>
							<button
								className="bg-amber-500 hover:bg-amber-700 text-white font-bold py-2 px-8 rounded uppercase"
								onClick={handleCreate}>
								create
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default AddCategory;
